export const sharedProductSwapping = {
  availability: {
    title: "Availability",
    discontinued: {
      details: "Unavailable",
    },
    backordered: {
      details: "Delayed",
    },
    outofstock: {
      details: "Estimated in stock 5-6 weeks",
    },
    estimatedInStock:
      "Estimated in stock in between {{expectedReturnMonth}}-{{additionalReturnMonth}}",
    noReturnDate: "Restock date pending. Check back soon or contact support.",
  },
  OriginalProductSwapped: "Original product was swapped.",
  ViewOriginalProduct: "View original product",
  OriginalProduct: "Original product",
  dosageInstructions: "Dosage instructions",
  Close: "Close",
  Size: "Size",
} as const;
